module.exports = __webpack_public_path__ + "img/impressionen_grill.47552574.jpg";